import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'app/reducers';
import { logout } from 'app/modules/auth/_state/auth.actions';
import { Subscription } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class IdleTimeoutService {
  private timeoutId: any;
  private idleTime: number = 300000; // 5 minute in milliseconds
  private routerEventsSubscription: Subscription;
  private currentRoute: string = '';
  private componentInstance: any;
  constructor(private store: Store<AppState>, private router: Router){}

  startWatching(componentInstance: any): void {
    this.componentInstance = componentInstance;
    this.routerEventsSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentRoute = event.urlAfterRedirects;
        this.checkIfAuthRoute();
      }
    });

    // Listen for user activity
    ['click', 'mousemove', 'keydown', 'scroll', 'touchstart'].forEach((event) =>
      document.addEventListener(event, () => this.handleUserActivity())
    );
  }

  private checkIfAuthRoute(): void {
    if (this.currentRoute.includes('auth')) {
      this.clearTimeout(); // Stop the timer on auth routes
    } else if (this.currentRoute.includes('app')){
      this.resetTimeout(); // Start the timer on non-auth routes
    }
  }

  private handleUserActivity(): void {
    if (this.currentRoute.includes('app')) {
      this.resetTimeout();
    }
  }
  // private handleUserActivity(): void {
  //   if (!this.currentRoute.includes('auth')) {
  //     this.resetTimeout();
  //   }
  // }

  private resetTimeout(): void {
    this.clearTimeout(); // Clear any existing timeout

    // Set a new timeout
    this.timeoutId = setTimeout(() => {
      this.logout();
    }, this.idleTime);
  }

  private clearTimeout(): void {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }

  private showInactivityModal(): void {
    if (this.componentInstance) {
      this.componentInstance.toggleErrorModal('open'); // Open the custom modal
    }
  }

  private logout(): void {
    this.showInactivityModal()
    this.store.dispatch(logout());
  }
  

  stopWatching(): void {
    // Cleanup when the service is stopped
    if (this.routerEventsSubscription) {
      this.routerEventsSubscription.unsubscribe();
    }
    this.clearTimeout();
  }

}


